import React from 'react';
import { Nullable } from '@benzinga/utils';
import { numberShorthand } from '@benzinga/utils/numberUtils';
import { FundamentalInfoDataCell, FundamentalInfoContainer, FundamentalsContainer } from '../FundamentalInfo';
import { isQuoteTradeTimesEquals } from '@benzinga/quotes-manager/utils';
import type { DelayedQuote } from '@benzinga/quotes-manager';

export interface StockFundamentalsProps {
  columns?: number;
  hideDataCell?: number[];
  stock: Nullable<StockFundamentalsStockData>;
  labels?: {
    dividend?: string;
  };
}

export interface StockFundamentalsStockData extends DelayedQuote {
  dividend?: number | null;
  dividendYield?: number | null;
  forwardDividend?: number | null;
  eps?: number | null;
  payoutRatio?: number | null;
}

export const StockFundamentals = React.memo(({ columns, hideDataCell, stock }: StockFundamentalsProps) => {
  // const renderDividendYield = `${stock.dividend ? numberShorthand(stock.dividend, 3) : '-'} / ${
  //   stock.dividendYield ? formatPercentage(Number(stock.dividendYield)) : '-'
  // }%`;
  const renderDayRange = `${numberShorthand(stock.low) || '-'} - ${numberShorthand(stock.high) || '-'}`;
  const renderVolumeAverage = `${numberShorthand(stock.volume) || '-'} / ${
    numberShorthand(stock.averageVolume) || '-'
  }`;
  const render52WeekRange = `${numberShorthand(stock.fiftyTwoWeekLow) || '-'} - ${
    numberShorthand(stock.fiftyTwoWeekHigh) || '-'
  }`;

  // const renderPayoutRatio = stock.payoutRatio ? numberShorthand(stock.payoutRatio) : '-';
  // const renderEPS = stock.eps ? numberShorthand(stock.eps) : '-';

  const MappableElements = [
    <FundamentalInfoDataCell name="Open" value={`${numberShorthand(stock.open) || '-'}`} />,
    <FundamentalInfoDataCell name="Close" value={`${stock.close ? numberShorthand(stock.close) : '-'}`} />,
    // <FundamentalInfoDataCell
    //   name="Float / Outstanding"
    //   value={`${stock.sharesFloat ? numberShorthand(stock.sharesFloat) : '-'} / ${
    //     stock.sharesOutstanding ? numberShorthand(stock.sharesOutstanding) : '-'
    //   }`}
    // />,
    <FundamentalInfoDataCell name="Vol / Avg." value={renderVolumeAverage} />,
    <FundamentalInfoDataCell name="Mkt Cap" value={numberShorthand(stock.marketCap) || '-'} />,
    // <FundamentalInfoDataCell name="P/E" value={stock.pe ? numberShorthand(stock.pe) : '-'} />,
    // <FundamentalInfoDataCell name="50d Avg. Price" value={numberShorthand(stock.fiftyDayAveragePrice) || '-'} />,
    // <FundamentalInfoDataCell
    //   name={labels?.dividend ? labels.dividend : 'Div / Yield (Forward)'}
    //   value={renderDividendYield}
    // />,
    // <FundamentalInfoDataCell name="Payout Ratio" value={renderPayoutRatio} />,
    // <FundamentalInfoDataCell name="Total Float" value={stock.sharesFloat ? numberShorthand(stock.sharesFloat) : '-'} />,
    // <FundamentalInfoDataCell name="EPS" value={renderEPS} />,
    <FundamentalInfoDataCell name="Day Range" value={renderDayRange} />,
    <FundamentalInfoDataCell name="52 Wk Range" value={render52WeekRange} />,
  ];

  return (
    <FundamentalsContainer className="stock-fundamentals" columns={columns} hideDataCell={hideDataCell}>
      <tbody className="fundamentals-tbody">
        {/* Map the 12 items into 1, 2, or 3 FundamentalInfoContainers */}
        {columns === 1 ? (
          <FundamentalInfoContainer>
            {MappableElements.map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        ) : columns === 2 ? (
          <FundamentalInfoContainer>
            {MappableElements.slice(0, 3).map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        ) : (
          <FundamentalInfoContainer>
            {MappableElements.slice(0, 2).map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        )}
        {columns === 2 && (
          <FundamentalInfoContainer>
            {MappableElements.slice(3, 6).map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        )}
        {columns === 3 && (
          <FundamentalInfoContainer>
            {MappableElements.slice(2, 4).map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        )}
        {columns === 3 && (
          <FundamentalInfoContainer>
            {MappableElements.slice(4, 6).map((element, index) => (
              <React.Fragment key={index}>{element}</React.Fragment>
            ))}
          </FundamentalInfoContainer>
        )}
      </tbody>
    </FundamentalsContainer>
  );
}, isQuoteTradeTimesEquals);
